/*
 * File: Loader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:40:21 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Col, Layout, Row, Typography } from 'antd';
import { BlockLoader } from 'components/atoms/BlockLoader';
import { FC } from 'react';
import { InlineStylesModel } from '../../models/InlineStylesModel';

const { Content } = Layout;

interface Props {
  isDarkMode?: boolean;
  fullHeight?: boolean;
  transparent?: boolean;
  componentLoader?: boolean;
  loadingText?: string;
}

export const Loader: FC<Props> = ({ isDarkMode, fullHeight = false, transparent = false, componentLoader = false, loadingText = 'Loading...' }) => {
  // Theme-specific colors

  // Theme-specific colors
  const bgColor = isDarkMode ? 'rgb(31, 30, 46)' : '#f0f2f5';

  const styles: InlineStylesModel = {
    content: {
      textAlign: 'center'
    },
    layout: {
      height: fullHeight ? '100vh' : componentLoader ? '100%' : '80vh',
      backgroundColor: transparent ? 'transparent' : bgColor
    },
    mainRow: {
      height: fullHeight ? '100vh' : componentLoader ? '100%' : '80vh'
    }
  };

  return (
    <Layout style={styles.layout}>
      <Content style={styles.content}>
        <Row justify="center" align="middle" style={styles.mainRow}>
          <Col span={24} style={{ height: componentLoader ? '50%' : undefined }}>
            <BlockLoader direction="loader loader--slideUp" />
          </Col>
          <Col span={24}>
            {componentLoader && (
              <Typography.Text type="secondary" style={{ fontSize: 16, color: isDarkMode ? '#fff' : '#000' }}>
                {loadingText}
              </Typography.Text>
            )}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};
